import {useMemo} from "react";

import {filterGuests, filterMeasurements} from "../model";

type UseMeasurementListViewProps = {
  guests: any[];
  measurements: any[];
  search: string;
  selectedMetric: string;
  selectedGuestId: string;
};

export const useMeasurementListView = ({
  guests,
  measurements,
  search,
  selectedMetric,
  selectedGuestId,
}: UseMeasurementListViewProps) => {
  const filteredGuests = useMemo(() => {
    return filterGuests({guests, search});
  }, [guests, search]);

  const filteredMeasurements = useMemo(() => {
    return filterMeasurements({
      measurements,
      selectedMetric,
      selectedGuestId,
    });
  }, [measurements, selectedMetric, selectedGuestId]);

  return {
    filteredGuests,
    filteredMeasurements,
  };
};
